<div class="d-flex justify-content-between">
  <div [class]="{ 'warning': hasIssue }">{{ shareClass }}</div>

  @if (hasIssue) {
    <div
      class="warning-icon"
      container="body"
      placement="top"
      tooltipClass="share-tooltip"
      [ngbTooltip]="issueMessage"
    >
      <i class="icon ic-alert-triangle-16"></i>
    </div>
  }
</div>
